import React from 'react';

import { Route } from 'helpers/routes/routes';
import { CommonPageData } from 'helpers/routes/CommonPageData';

export enum BillingManagementClaimStepsRoute {
  ClaimStep1 = '/billing/claim/step1',
  ClaimStep2 = '/billing/claim/step2',
  ClaimStep3 = '/billing/claim/step3',
  ClaimStep4 = '/billing/claim/step4',
  ClaimStep5 = '/billing/claim/step5',
  ClaimStep6 = '/billing/claim/step6',
  ClaimStep7 = '/billing/claim/step7',
}

const defaultCommonPageData: CommonPageData = {
  pageTitle: 'onecrm.common.pageTitle.billing',
  visibleForAnonym: false,
};

export const BillingManagementClaimsStepsRoutes: Route[] = [
  {
    path: BillingManagementClaimStepsRoute.ClaimStep1,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep1/ClaimStep1')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep2,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep2/ClaimStep2')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.1',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep3,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep3/ClaimStep3')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.2',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep4,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep4/ClaimStep4')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.3',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep5,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep5/ClaimStep5')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.4',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep6,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep6/ClaimStep6')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.5',
    },
  },
  {
    path: BillingManagementClaimStepsRoute.ClaimStep7,
    exact: true,
    component: React.lazy(() => import('views/pages/EBill/Claims/ClaimStep7/ClaimStep7')),
    commonPageData: {
      ...defaultCommonPageData,
      pageId: '2.2.1.1.4.6',
    },
  },
];
